module.exports = __webpack_public_path__ + "assets/img/922005.ae6c8b0d.jpg";